import React from 'react';
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';

import { connect } from "react-redux";
import { patchCryptoLink } from 'redux/crypto-links/actions';
import { setLastPatchedId } from 'redux/common/actions';

import Parser from 'html-react-parser';

import CommonInputField from 'components/elements/inputs/CommonInputField';
import ProFeaturePlaceholder from 'components/common/ProFeaturePlaceholder';

import './CryptoLinkCustomLabel.css';

function CryptoLinkCustomLabel(props) {
  const {
    patchCryptoLink,
    setLastPatchedId,
    linkItem,
    patchCryptoLinkError,
    lastPatchedId,
    me,
  } = props;
  const { t } = useTranslation();

  const validation = value => {
    if (!value) {
      return 'Custom Label should not be empty';
    }
    return null;
  };

  return (
    <div className="crypto-link-custom-label__component">
      <div className="label-icon">
        {Parser(linkItem.crypto_service.icon_svg)}
      </div>

      <ProFeaturePlaceholder
        noKeyIcon
        locked={
          me &&
          me.subscription &&
          !me.subscription.ff_crypto_links
        }
        placeholderContent={
          <div>
            {t("You can change Custom Label on the")} <strong>PRO</strong> {t("plan")}.
          </div>
        }
      >
        <CommonInputField
          key={`crypto-link-custom-label-input-key-${linkItem.id}`}
          editIcon
          initialValue={linkItem.custom_label || linkItem.crypto_service.form_label}
          disabled={
            me &&
            me.subscription &&
            !me.subscription.ff_crypto_links
          }
          executedFunction={value => {
            const form = new FormData();
            form.append('custom_label', value);
            patchCryptoLink(linkItem.id, form);
            setLastPatchedId(linkItem.id);
          }}
          serverErrors={
            lastPatchedId === linkItem.id &&
            patchCryptoLinkError &&
            patchCryptoLinkError.custom_label
          }
          validationFunction={validation}
        />
      </ProFeaturePlaceholder>
    </div>
  );
}

CryptoLinkCustomLabel.propTypes = {
  patchCryptoLink: PropTypes.func.isRequired,
  setLastPatchedId: PropTypes.func.isRequired,
  linkItem: PropTypes.object.isRequired,
  patchCryptoLinkError: PropTypes.object,
  lastPatchedId: PropTypes.number,
  me: PropTypes.object,
};

CryptoLinkCustomLabel.defaultProps = {
  me: null,
  patchCryptoLinkError: null,
  lastPatchedId: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    patchCryptoLinkError: state.cryptoLinksReducer.patchCryptoLinkError,
    lastPatchedId: state.commonReducer.lastPatchedId,
  }
);

export default connect(
  mapStateToProps,
  {
    patchCryptoLink,
    setLastPatchedId,
  },
)(CryptoLinkCustomLabel);
